import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { EmployeeRole } from '@/api/apis/resources';

export const useCanCreateKidneyCase = () => {
  const { roles } = useContext(AuthContext);
  return roles.includes(EmployeeRole.TechSupportAdmin);
};
